export default __webpack_public_path__ + "static/media/Present.ab65fb11.svg";